import { Button } from "react-bootstrap";
import { BiPlus } from "react-icons/bi";
import { BsXCircle } from "react-icons/bs";
import Context from "../../../context/Context";
import { useContext } from "react";

const OrgNode = ({
    nodeDatum,
    selectedNode,
    setSelectedNode,
    data,
    setData,
    openAdd,
    openEdit,
    deleteNode,
    isAddEdit
}) => {

    const { user } = useContext(Context);

    const isSelected = selectedNode && selectedNode.email === nodeDatum.email;
    const isRoot = nodeDatum.email === data.email;
    const role = isRoot ? "Company Head" : (nodeDatum.role || "Member");

    return (
        <g onClick={() => openEdit(nodeDatum)} style={{ cursor: 'pointer' }}>
            <foreignObject width={220} height={110} x={-110} y={-80} style={{ overflow: "visible" }}>
                <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    className={`node-card ${isSelected ? 'selected' : ''}`}
                    style={{
                        border: isSelected ? '1px solid #000' : '1px solid #a7a3a3ff',
                        padding: '8px',
                        paddingTop: '18px',
                        paddingBottom: '28px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        background: '#fff',
                        color: '#000',
                        position: 'relative',
                        zIndex: -1,
                        borderRadius: '6px',
                        overflow: 'visible',
                    }}
                >

                    {nodeDatum.department && (
                        <div
                            style={{
                                position: "absolute",
                                top: "-14px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                background: "#000",
                                color: "#fff",
                                fontSize: "11px",
                                padding: "4px 18px",
                                borderRadius: "10px",
                                whiteSpace: "nowrap",
                                zIndex: 999

                            }}
                             className="!rounded-full font-bold"
                        >
                            {nodeDatum.department}
                        </div>
                    )}

                    {(nodeDatum.manual || role === "Member") && user?.role === "Company Head" && (
                        <Button
                            onClick={(e) => {
                                e.stopPropagation();
                                const newData = { ...data };
                                deleteNode(nodeDatum.email, nodeDatum.department, newData);
                                setData(newData);
                                if (selectedNode?.email === nodeDatum.email) {
                                    setSelectedNode(null);
                                }
                            }}
                            style={{
                                position: 'absolute',
                                top: '6px',
                                right: '6px',
                                width: '22px',
                                height: '22px',
                                background: '#fff',
                                border: '1px solid #aaa',
                                borderRadius: '50%',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: 0,
                            }}
                        >
                            <BsXCircle color='red' />
                        </Button>
                    )}

                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <img
                            src={nodeDatum.img || 'https://cdn-icons-png.flaticon.com/512/847/847969.png'}
                            alt={`${nodeDatum.first_name} ${nodeDatum.last_name}`}
                            style={{ width: '45px', height: '45px', borderRadius: '50%', marginRight: '12px', objectFit: 'cover' }}
                        />
                        <div style={{ flexGrow: 1 }}>
                            <div style={{ fontSize: '16px' }} className="font-normal">
                                {nodeDatum.first_name} {nodeDatum.last_name}
                            </div>
                            <div style={{ fontSize: '14px' }} className="text-[#828282] font-normal" >{role}</div>
                        </div>
                    </div>

                    {(isAddEdit && role.replace(/\s+/g, '') !== "Member") && (
                        <span
                            style={{ marginTop: '24px', fontSize: '12px', background: '#000', color: '#fff', border: 'none', }}
                            className="p-1 border rounded-circle"
                            onClick={(e) => {
                                e.stopPropagation();
                                openAdd(nodeDatum);
                            }}
                        >
                            <BiPlus size={21} />
                        </span>
                    )}
                </div>
            </foreignObject>
        </g>
    );
};

export default OrgNode;
